import { ProductsPerInsuranceTarget } from '@core/models/products-per-insurance-target.model';
import { createAction, props } from '@ngrx/store';

export const updateProductsPerInsuranceTarget = createAction(
  '[RecommendedProducts] Update products per insurance target',
  props<{ newProductsPerInsuranceTarget: ProductsPerInsuranceTarget }>()
);
